import { render, staticRenderFns } from "./WorkflowFormDialog.vue?vue&type=template&id=4c576169&"
import script from "./WorkflowFormDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports